import { useEffect, useState } from "react";
import { IRecords } from "../../../types";
import { TabContainer, Tab } from "./../../tab";
import strategyIcon from "./../../../images/growth.png";
import chainIcon from "./../../../images/chain.png";
import trendingIcon from "./../../../images/trending.png";
import WatchlistTab from "./watchlist-tab";
import { lotSize } from "../../../data/holidaysList";
import PositionsTab from "./positions-tab";

const serverUrl = "https://optionstrategies.in/home/getdata?url=";

const supportedURLs = ["NIFTY", "BANKNIFTY", "FINNIFTY"];
const refreshTimer = 5 * 60 * 1000;

const VirtualTrading = () => {
  const [records, setRecords] = useState<{ [key: string]: IRecords }>({});

  const fetchData = async (dataUrl: string) => {
    const url = serverUrl + dataUrl;
    const res = await (await fetch(url)).json();
    if (res.records && res.records !== "" && res.records.length > 10) {
      records[dataUrl] = JSON.parse(res.records).records;
      setRecords({...records});
    }
    setTimeout(fetchData.bind(null, dataUrl), refreshTimer);
  };

  useEffect(() => {
    if (Object.keys(records).length === 0) {
      supportedURLs.map((url) => fetchData(url));
    }
  }, [records]);
  return (
    <div className="e-settings-layout">
      {Object.keys(records).length > 0 ? (
        <TabContainer style={{ marginBottom: "5px" }}>
          {Object.keys(records).map((key) => (
            <Tab key={key} name={key}>
              In Development
            </Tab>
          ))}
          <Tab name="Positions" icon={trendingIcon}>
            In Development
          </Tab>
        </TabContainer>
      ) : (
        <div style={{ textAlign: "center" }}>
          <p>
            Please wait for the data to load. It might take a minute or two due
            to restrictions on the number of data request imposed by our data
            vendor.
          </p>
          <p>
            If data not received, this app will try to get the data
            automatically after every 5 seconds.
          </p>
          <progress></progress>
          <p>
            If the data is not available even after few minutes please inform us
            at support@optionstrategies.in or in our telegram channel
            https://t.me/optionstrategybuilder
          </p>
        </div>
      )}
    </div>
  );
};

export default VirtualTrading;
